import { Role } from '@/api/types'

export default [
    {
        path: '/',
        redirect: { name: 'leaderboard' },
    }, {
        name: 'leaderboard',
        path: '/leaderboard',
        meta: {
            requiredRole: Role.EMPLOYEE,
            showScrollbar: false,
            noBackground: true,
            label: 'Leaderboard',
        },
        component: () => import(/* webpackChunkName: "dashboard" */ '../../views/Gamification/Leaderboard.vue'),
    },
]
